import React from "react";
import styles from "./styles.module.scss";
import clsx from "clsx";

interface TileProps {
  children: any;
  className?: string;
}

const Tile = ({ children, className }: TileProps) => {
  return (
    // the classNames are concatenated wrong and need to be fixed. styles[className] = "pick the className from the styles in this stylesheet". It should be just className, i.e. pass down the styles from whichever component is rendering this component.
    <div className={clsx(styles["wone-goal-tile"], styles[className || ""])}>
      {children}
    </div>
  );
};
export default Tile;
